import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  cardGrid: {
    padding: "20px 0",
  },
  pagination: {
    borderRadius: 34,
    marginTop: "4rem",
    justifyContent: "center",
    margin: "auto",
    width: 350,
    padding: "10px",
  },
}));
